import { Stack, Typography } from "@mui/material";
import { LIST_REGISTRY_TAG_LIMIT } from "../../constants";
import { RegistryTagChip } from "./RegistryTagChip";
import type { ListRegistryTag } from "../../types";

interface Props {
  tags: ListRegistryTag[];
}

/**
 * 一覧の行・カードに出す公表情報のタグ（小さいチップ）
 * @param props.tags 法人に付いたタグ
 * @returns タグの並び。タグが無ければ何も出さない
 */
export const RegistryTagList: React.FC<Props> = ({ tags }) => {
  if (!tags.length) return null;
  const shown = tags.slice(0, LIST_REGISTRY_TAG_LIMIT);
  const rest = tags.length - shown.length;
  return (
    <Stack
      direction="row"
      spacing={0.5}
      flexWrap="wrap"
      useFlexGap
      alignItems="center"
    >
      {shown.map((tag) => (
        <RegistryTagChip key={tag.code} tag={tag} dense />
      ))}
      {rest > 0 ? (
        <Typography variant="caption" color="text.secondary">
          ほか{rest}
        </Typography>
      ) : null}
    </Stack>
  );
};
